module.exports = __webpack_public_path__ + "static/media/icon_100.021ccb14.svg";